// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"styles_boxContainer__3ClRs","line":"styles_line__1d_nU"};